"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _ramda = require("ramda");

var _propTypes = require("prop-types");

var _components = require("../../components");

var _primitives = _interopRequireDefault(require("../../primitives"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var propTypes = {
  /** Container class name */
  className: _propTypes.string,

  /** color from the color scheme */
  colorScheme: _propTypes.string,

  /** cypress test id */
  "data-test-id": _propTypes.string,

  /** list data to create flex block three list */
  items: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    /** target attribute */
    attributes: (0, _propTypes.oneOfType)([(0, _propTypes.arrayOf)(_propTypes.string), _propTypes.object]),

    /** href provided to Cta for links */
    href: _propTypes.string,

    /** Cta size, determines which size styling to apply */
    size: _propTypes.string,

    /** id given to glyph */
    style: _propTypes.string.isRequired,

    /** Determines what to render for the Cta. */
    tag: (0, _propTypes.oneOfType)([_propTypes.node, _propTypes.func]),

    /**  */
    text: _propTypes.node
  }))
};
var defaultProps = {
  colorScheme: null
};

function HtmlCta(_ref) {
  var className = _ref.className,
      colorScheme = _ref.colorScheme,
      dataTestId = _ref["data-test-id"],
      items = _ref.items;
  return /*#__PURE__*/_react["default"].createElement(_primitives["default"].Box, {
    className: className,
    "data-test-id": dataTestId,
    my: 2
  }, items && (0, _ramda.map)(function (_ref2) {
    var attributes = _ref2.attributes,
        href = _ref2.href,
        size = _ref2.size,
        style = _ref2.style,
        tag = _ref2.tag,
        text = _ref2.text;
    return /*#__PURE__*/_react["default"].createElement(_components.Cta, _extends({
      key: href,
      color: colorScheme,
      darkUi: colorScheme === "white",
      glyphRight: style && /*#__PURE__*/_react["default"].createElement(_components.Glyph, {
        id: style
      }),
      size: size,
      tag: tag,
      url: href,
      version: "link"
    }, attributes), text);
  }, items));
}

HtmlCta.defaultProps = defaultProps;
HtmlCta.propTypes = propTypes;
HtmlCta.displayName = "Modules.HtmlCta";
var _default = HtmlCta;
exports["default"] = _default;